// src/components/ui/Skeleton/index.tsx
import React from "react";
import { SkeletonBlock } from "./styles";

interface SkeletonProps {
  width?: string;
  height?: string;
  radius?: number;
  circle?: boolean;
  style?: React.CSSProperties;
}

/** Bloco de carregamento com shimmer, no lugar de spinners/modais bruscos. */
export default function Skeleton({
  width,
  height,
  radius,
  circle,
  style,
}: SkeletonProps) {
  return (
    <SkeletonBlock
      data-testid="skeleton"
      $width={width}
      $height={height}
      $radius={radius}
      $circle={circle}
      style={style}
    />
  );
}
